"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceTextWithEntity = exports.insertEntity = void 0;

var _draftJs = require("draft-js");

var insertEntity = function insertEntity(editorState, entityKey, text) {
  var selection = editorState.getSelection();
  var modifierMethod = selection.isCollapsed() ? _draftJs.Modifier.insertText : _draftJs.Modifier.replaceText;
  return _draftJs.EditorState.push(editorState, modifierMethod(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle(), entityKey), 'insert-characters');
};

exports.insertEntity = insertEntity;

var replaceTextWithEntity = function replaceTextWithEntity(editorState, phraseData, entityKey) {
  var _phraseData$toObject = phraseData.toObject(),
      phrase = _phraseData$toObject.phrase,
      offset = _phraseData$toObject.offset,
      blockKey = _phraseData$toObject.blockKey;

  var meetingSelection = _draftJs.SelectionState.createEmpty(blockKey).merge({
    anchorOffset: offset,
    focusOffset: offset + phrase.length
  });

  var editorStateWithSelection = _draftJs.EditorState.forceSelection(editorState, meetingSelection);

  return insertEntity(editorStateWithSelection, entityKey, phrase);
};

exports.replaceTextWithEntity = replaceTextWithEntity;